import React from "react";
import PropTypes from "prop-types";
import CustomButton from "./customButton";

const SFButton = (props) => {
  return <CustomButton {...props}>{props.children}</CustomButton>;
};

SFButton.defaultProps = {
  variant: "primary",
  size: "medium",
  disabled: false,
  children: null,
  type: "submit",
  onClick: null,
  fullWidth: false,
  icon: null,
  endIcon: null,
  href: null
};

SFButton.propTypes = {
  variant: PropTypes.oneOf([
    "primary",
    "secondary",
    "utility",
    "text-link",
  ]),
  type: PropTypes.oneOf(["submit", "reset", "button"]),
  onClick: PropTypes.func,
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]),
  fullWidth: PropTypes.bool,
  icon: PropTypes.object,
  endIcon: PropTypes.object,
};

export default SFButton;
